/** Board is GRID_SIZE × GRID_SIZE cells. */
export const GRID_SIZE = 9;

/** Board units per cell. The SVG viewBox is expressed in these. */
export const CELL = 100;

/**
 * How far a wire reaches, in cells (Chebyshev).
 * This one number is the whole game: 1-wide water is crossable from either
 * bank, 2-wide lakes and doubled ranges are not.
 */
export const SPAN = 2;

/** Daily grid #1. */
export const EPOCH = { year: 2026, month: 0, day: 1 } as const;

/** Height of the sky band above the board — HUD strip plus headroom for the giants. */
export const SKY_BAND = 52;
